'use strict';
'use client';
import { j as e } from "../../external/react/jsx-runtime.js";
import { FontAwesomeIcon as t } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import { faMinus as p, faCheck as u } from "../../external/@fortawesome/pro-solid-svg-icons/index.js";
import c from "../../external/classnames/index.js";
import { useTheme as x } from "../Provider/index.js";
const j = ({
  name: r,
  label: o,
  checked: i,
  error: d,
  required: s,
  indeterminate: n,
  ...l
}) => {
  const { isMosh: a, isMoshy: h } = x(), b = c(
    "peer appearance-none bg-white border-2 border-grey-300 rounded-lg data-[has-error=true]:border-red-error transition-colors cursor-pointer",
    "focus-within:outline focus-within:outline-2 focus-within:outline-blue focus-within:border-none checked:focus-within:outline-none",
    "disabled:bg-grey-300 disabled:border-grey-300 disabled:text-grey-400 disabled:cursor-not-allowed disabled:hover:bg-grey-300 disabled:hover:border-grey-300",
    {
      "checked:bg-green-dark checked:border-green-dark checked:hover:bg-green checked:hover:border-green": a,
      "checked:bg-blue-dark checked:border-blue-dark checked:hover:bg-purple checked:hover:border-purple": h
    }
  );
  return /* @__PURE__ */ e.jsx("div", { className: "flex flex-col gap-1", children: /* @__PURE__ */ e.jsxs("div", { className: "flex items-start gap-3", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "relative size-6 flex-shrink-0", children: [
      /* @__PURE__ */ e.jsx(
        "input",
        {
          type: "checkbox",
          id: r,
          name: r,
          checked: i,
          required: s,
          "data-has-error": d,
          className: c(b, "size-full"),
          ...l
        }
      ),
      n ? /* @__PURE__ */ e.jsx(
        t,
        {
          icon: p,
          className: "absolute text-white left-[5px] top-[5px] pointer-events-none",
          "data-testid": "indeterminate-icon"
        }
      ) : /* @__PURE__ */ e.jsx(
        t,
        {
          icon: u,
          className: "absolute text-white left-[5px] top-[5px] hidden peer-checked:block pointer-events-none"
        }
      )
    ] }),
    o ? /* @__PURE__ */ e.jsxs("div", { className: "flex items-center", children: [
      /* @__PURE__ */ e.jsx("label", { className: "p1 cursor-pointer", htmlFor: r, children: o }),
      s ? /* @__PURE__ */ e.jsx("span", { className: "text-red-error pl-1", children: "*" }) : null
    ] }) : null
  ] }) });
};
export {
  j as default
};
